// src/containers/clients/MergeClientsContainer.js
import React from "react";
import { Switch, Route, Redirect, withRouter } from "react-router-dom";
import Header from "../../components/shared/header/header";
import Sidebar from "../../components/shared/sidebar/sidebar";
import ClientMerge from "../../components/clients/ClientMerge";
import Styles from "../../components/shared/css/default.module.css";
import { connect } from "react-redux";
import { getToken } from "../../helpers/utility";


class MergeClientsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSidebarOpen: false,
    };
  }

  toggleSidebar = () => {
    this.setState({ isSidebarOpen: !this.state.isSidebarOpen });
  };

  render() {
    // Optional: guard for auth if needed
    const isAuthenticated = !!getToken();
    if (!isAuthenticated) {
      return <Redirect to="/login" />;
    }

    return (
      <div id={Styles["wrapper"]} className={this.state.isSidebarOpen ? Styles.toggled : ""}>
        <Sidebar isSidebarOpen={this.state.isSidebarOpen} {...this.props} />
        <Header handleSidebar={this.toggleSidebar} {...this.props} />
        <div className={`${Styles.ml_main} mt-4`}>
          {/* Directly render the merge form */}
          <ClientMerge />
        </div>
      </div>
    );
  }
}

export default withRouter(connect()(MergeClientsContainer));
